import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import FailureAlert from '../Common/Failure';
import { CallBackAlert } from '../Common/Validations/validation';

const UploadEventImage = ({ EventDetails, HideUploadMenu, getEventRecord }) => {
    const [EventImage, setEventImage] = useState(null);

    const onImageUpload = () => {
        if (EventImage !== null) {
            let formData = new FormData();
            formData.append('file', EventImage);
            Axiosfetch(baseURL + "UploadEventImage", "POST", formData, EventImageSuccess, Failure);
        }
        else {
            CallBackAlert({ success: false, message: "Please Upload image" });
        }
    }

    const EventImageSuccess = (data) => {
        if (data.success) {
            UpdateEvent(data.filename);
        }
        else {
            CallBackAlert(data);
        }
    };

    const UpdateEvent = (filename) => {
        Axiosfetch(baseURL + "UpdateEventImagePath", "POST", {
            _id: EventDetails._id,
            Image: filename
        }, EventImagePathSuccess, Failure);
    }

    const EventImagePathSuccess = (data) => {
        if (data.success) {
            getEventRecord();
            CallBackAlert(data);
            HideUploadMenu();
        }
        else {
            CallBackAlert(data);
        }
    }

    const OnFileUpload = (e) => {
        var selectedFile = e.target.files[0];
        if (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png" ||
            selectedFile.type === "image/jpg") {
            setEventImage(selectedFile);
        }
        else {
            CallBackAlert({ success: false, message: "File Type allowed are : PNG , JPG, JPEG" });
            setEventImage(null);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div id="addProduct" className="modal" style={{ display: "block", paddingTop: "1%" }}>
            <div className="modal-content" style={{ width: "70%" }}>
                <div className={`modal-header header-style align-center`}>
                    <h6 className='pt-1' style={{ marginLeft: "5px" }}>Event Image Upload</h6>
                    <span className="close" onClick={HideUploadMenu}>&times;</span>
                </div>
                <div>
                    <input type="file" name="Logo"
                        className="form-control"
                        onChange={e => OnFileUpload(e)}
                        accept="image/jpeg, image/png"></input>
                </div>
                <button style={{ border: "none", padding: "5px 10px", borderRadius: "6px" }} className='mt-2 btn-primary' onClick={onImageUpload}>Upload</button>
            </div>
        </div>
    );
};

export default UploadEventImage;